import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import PieGraph from "../../../general/PieGraph";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./HealthL1.module.css";
import { HealthStore } from "./HealthStore";

function HealthL1({ distrito }) {
  const [frequenciaExame, setFrequenciaExame] = useState(null);
  const [atendimentoAmbulancia, setAtendimentoAmbulancia] = useState(null);
  const [sistemaSaude, setSistemaSaude] = useState(null);
  const [frequenciaExameOldValue, setFrequenciaExameOldValue] = useState(null);
  const [atendimentoAmbulanciaOldValue, setAtendimentoAmbulanciaOldValue] =
    useState(null);
  const [sistemaSaudeOldValue, setSistemaSaudeOldValue] = useState(null);

  const setFrequenciaExameValue = HealthStore(
    (state) => state.setFrequenciaExameValue
  );

  const setFrequenciaExameImage = HealthStore(
    (state) => state.setFrequenciaExameImage
  );

  const setAtendimentoAmbulanciaValue = HealthStore(
    (state) => state.setAtendimentoAmbulanciaValue
  );

  const setAtendimentoAmbulanciaImage = HealthStore(
    (state) => state.setAtendimentoAmbulanciaImage
  );

  const setSistemaSaudeValue = HealthStore(
    (state) => state.setSistemaSaudeValue
  );

  const setSistemaSaudeImage = HealthStore(
    (state) => state.setSistemaSaudeImage
  );

  const frequenciaExameValue = HealthStore(
    (state) => state.frequenciaExameValue
  );

  const atendimentoAmbulanciaValue = HealthStore(
    (state) => state.atendimentoAmbulanciaValue
  );

  const sistemaSaudeValue = HealthStore((state) => state.sistemaSaudeValue);

  const usoMedicamentoValue = HealthStore((state) => state.usoMedicamentoValue);

  const dificuldadeAtendimentoValue = HealthStore(
    (state) => state.dificuldadeAtendimentoValue
  );

  const possuiDoencaCronicaValue = HealthStore(
    (state) => state.possuiDoencaCronicaValue
  );

  const tipoDoencaCronicaValue = HealthStore(
    (state) => state.tipoDoencaCronicaValue
  );

  const programaSaudeRuralValue = HealthStore(
    (state) => state.programaSaudeRuralValue
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [frequenciaExame, atendimentoAmbulancia, sistemaSaude] =
          await Promise.all([
            Api.getFrequenciaExame(
              distrito,
              null,
              atendimentoAmbulanciaValue,
              sistemaSaudeValue,
              usoMedicamentoValue,
              dificuldadeAtendimentoValue,
              possuiDoencaCronicaValue,
              tipoDoencaCronicaValue,
              programaSaudeRuralValue
            ),
            Api.getAtendimentoAmbulancia(
              distrito,
              frequenciaExameValue,
              null,
              sistemaSaudeValue,
              usoMedicamentoValue,
              dificuldadeAtendimentoValue,
              possuiDoencaCronicaValue,
              tipoDoencaCronicaValue,
              programaSaudeRuralValue
            ),
            Api.getSistemaSaude(
              distrito,
              frequenciaExameValue,
              atendimentoAmbulanciaValue,
              null,
              usoMedicamentoValue,
              dificuldadeAtendimentoValue,
              possuiDoencaCronicaValue,
              tipoDoencaCronicaValue,
              programaSaudeRuralValue
            ),
          ]);
        setFrequenciaExame(Functions.buildPieGraphParams2(frequenciaExame));
        setAtendimentoAmbulancia(
          Functions.buildPieGraphParams2(atendimentoAmbulancia)
        );
        setSistemaSaude(Functions.buildSmallPieGraphParams(sistemaSaude));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };

    fetchData();
  }, [
    distrito,
    frequenciaExameValue,
    atendimentoAmbulanciaValue,
    sistemaSaudeValue,
    usoMedicamentoValue,
    dificuldadeAtendimentoValue,
    possuiDoencaCronicaValue,
    tipoDoencaCronicaValue,
    programaSaudeRuralValue,
  ]);

  const onFrequenciaExameClick = (value) => {
    setFrequenciaExameValue(value);
  };

  const onAtendimentoAmbulanciaClick = (value) => {
    setAtendimentoAmbulanciaValue(value);
  };

  const onSistemaSaudeClick = (value) => {
    setSistemaSaudeValue(value);
  };

  const onFrequenciaExameOldValue = (value) => {
    setFrequenciaExameOldValue(value);
  };

  const onAtendimentoAmbulanciaOldValue = (value) => {
    setAtendimentoAmbulanciaOldValue(value);
  };

  const onSistemaSaudeOldValue = (value) => {
    setSistemaSaudeOldValue(value);
  };

  return (
    <div className={styles.generalConditionL1}>
      {frequenciaExame && (
        <div className={styles.smallPiegraph}>
          <PieGraph
            data={frequenciaExame}
            text="FREQUÊNCIA DE EXAMES"
            onLegendClick={onFrequenciaExameClick}
            currentValue={frequenciaExameValue}
            oldValue={frequenciaExameOldValue}
            onOldValue={onFrequenciaExameOldValue}
            onImageReady={setFrequenciaExameImage}
          />
        </div>
      )}

      {atendimentoAmbulancia && (
        <div className={styles.smallPiegraph}>
          <PieGraph
            data={atendimentoAmbulancia}
            text="ATENDIMENTO AMBULÂNCIA"
            onLegendClick={onAtendimentoAmbulanciaClick}
            currentValue={atendimentoAmbulanciaValue}
            oldValue={atendimentoAmbulanciaOldValue}
            onOldValue={onAtendimentoAmbulanciaOldValue}
            onImageReady={setAtendimentoAmbulanciaImage}
          />
        </div>
      )}

      {sistemaSaude && (
        <div className={styles.smallPiegraph}>
          <SmallPieGraph
            data={sistemaSaude}
            text="SISTEMA DE SAÚDE"
            onLegendClick={onSistemaSaudeClick}
            currentValue={sistemaSaudeValue}
            oldValue={sistemaSaudeOldValue}
            onOldValue={onSistemaSaudeOldValue}
            onImageReady={setSistemaSaudeImage}
          />
        </div>
      )}
    </div>
  );
}

export default HealthL1;
